import { setNavChildren } from 'logic/theme';
import { selectSubscription } from 'logic/member';

export const Favourites = {
  template: `
    <div class="favourites--index bg-gray-100">
      <ui-view autoscroll="false"></ui-view>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const { title } = selectSubscription($ngRedux.getState().member);
        $ngRedux.dispatch(setNavChildren('favourites', title));
      },

      $onDestroy() {
        $ngRedux.dispatch(setNavChildren());
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Favourites/Favourites.js